import { ChartData } from 'chart.js';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { TransactionsDynamicSummaryItem } from 'types/embedded/dashboard';

export function useDashboardTransactionsDynamicSummaryChartData(
  data: TransactionsDynamicSummaryItem[],
): ChartData<'bar', number[], string> {
  const translate = useTypedTranslate();

  return {
    labels: data.map((item) => item.label),

    datasets: [
      {
        label: translate('app.dashboard.transactionsDynamicSummary.deposits'),
        data: data.map((item) => Number.parseFloat(item.convertedPaymentAmount) || 0),
        backgroundColor: '#81C784',
      },
      {
        label: translate('app.dashboard.transactionsDynamicSummary.withdrawals'),
        data: data.map((item) => Number.parseFloat(item.convertedPayoutAmount) || 0),
        backgroundColor: '#1976D2',
      },
    ],
  };
}
